import React from 'react';

import { usePackagePlaylist } from '@hooks/API/Packages/UsePackagePlaylist';

import NwDrawer from '@components/Gui/NwDrawer';
import PackagePlayListView from '@components/PackageDrawer/PackagePlayListView';

const PackagePlayListDrawer = ({ packageplaylistid, onClose }) => {
    const { data: playlistData } = usePackagePlaylist(packageplaylistid);
    return (
        <NwDrawer
            width={'90%'}
            modalDrawer
            onClose={onClose}
            title={playlistData ? playlistData.Name : 'Loading playlist...'}
        >
            {playlistData && <PackagePlayListView packagePlaylist={playlistData} />}
        </NwDrawer>
    );
};

export default PackagePlayListDrawer;
